import React, { useEffect } from 'react'
import { useHistory } from "react-router-dom";
import { Redirect } from 'react-router'
import { prop, map, defaultTo, compose } from 'ramda'
import { useFetch } from '../../hooks'
import { Store } from '../../context/store'
import { getTranslation, renderData, parseObjectToArray, isExists, sortByInt, getDataByKey } from '../../helpers'
import Header from '../../modules/Header'
import Footer from '../../modules/Footer'
import InfoBar from '../../modules/InfoBar'
import Box from '../../components/Box'
import Boxes from '../../components/Boxes'
import Container from '../../components/Container'
import FakeLoaderBox from '../../components/FakeLoaderBox'
import Wrapper from '../../components/Wrapper'
import FromSelect from '../../components/inputs/FromSelect'
import Button from '../../components/inputs/Button'
import { MonitoringStyled } from './styled'

const Monitoring = () => {
  const history = useHistory();
  const { state: { monitoring, group: { selected: selectedGroup } }, actions } = Store()

  const { response: resMaintiles } = useFetch({
    url: `/maintiles`,
    method: 'GET',
    loader: false
  })

  const { error: errorMaintiles, fetching: fetchingMaintiles, doFetch: getMaintiles } = useFetch({
    url: '/rpc/get_maintiles',
    method: 'POST',
    action: actions.setMonitoring
  })

  const { response: resDelays } = useFetch({
    url: '/rpc/get_delays',
    method: 'POST',
    action: actions.setDelays,
    lazy: false,
    loader: false
  })

  useEffect(() => {
    getMaintiles({
      data: {
        grpid: parseInt(selectedGroup, 10)
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedGroup])

  const parseMygrplist = compose(
    defaultTo([]),
    map(item => ({ value: item.grp_id === null ? '' : item.grp_id, label: item.grp_name }))
  )

  const grpSelect = getDataByKey(resMaintiles, 'grp_select')

  const renderDataState = renderData({ data: monitoring, error: errorMaintiles, fetching: fetchingMaintiles })

  const sortBoxes = sortByInt({ direct: 'asc', key: 'order' })

  const handleChangeGroup = event => actions.setSelectedGroup(event.target.value)

  const handleClickManageGroup = () => {
    const group = grpSelect && grpSelect.groups.find(group => parseInt(group.grp_id, 10) === parseInt(selectedGroup, 10))
    if (group !== undefined) {
      actions.setGroupsList([group]);
      history.push({ pathname: `/manage/mygroups/${group.grp_name}`, state: { grpid: group.grp_id } })
    }
  }

  if (isExists(prop('data', resDelays)) && prop('data', resDelays)) {
    return <Redirect to="/monitoring/urgent" />
  }

  return (
    <MonitoringStyled>
      <Header />
      {
        grpSelect &&
        <Container>
          <Wrapper>
            <FromSelect
              name='group'
              onChange={handleChangeGroup}
              value={selectedGroup}
              options={parseMygrplist(grpSelect.groups)}
              maxWidth='200px'
              disabled={fetchingMaintiles}
              noMargin
            />
            {
              selectedGroup !== '' &&
              <Button
                noMargin
                style={{ height: '50px' }}
                onClick={handleClickManageGroup}
                disabled={fetchingMaintiles}
              >
                {grpSelect.buttons.save}
              </Button>
            }
          </Wrapper>
        </Container>
      }
      <InfoBar lastUpdate={resMaintiles.lastUpdate} translation={{ info: getTranslation(resMaintiles, 'info') }} />
      <Container>
        <Boxes>
          {
            renderDataState({
              fetching: () => (<FakeLoaderBox numberItems={6} withWarnings />),
              error: error => <div>{error.toString()}</div>,
              data: ({ data = [] }) => (
                sortBoxes(parseObjectToArray(data))
                  .map(box => (
                    <Box
                      key={box.to}
                      to={{
                        pathname: `/monitoring/${box.to}`,
                        state: {
                          endpoint: box.endpoint
                        }
                      }}
                      title={box.label}
                      warning={box.warning}
                      alarm={box.alarm}
                      active={box.showme}
                      bordercolor={box.bordercolor}
                      info={box.info}
                    />
                  ))
              ),
            })
          }
        </Boxes>
      </Container>
      <Footer />
    </MonitoringStyled >
  )
}

export default Monitoring
